// import vue
import Vue from 'vue'

// import cookies
import VueCookies from 'vue-cookies'

Vue.use(VueCookies)
